import { render, staticRenderFns } from "./HoldingsPieChart.vue?vue&type=template&id=7e949bd7&scoped=true&"
import script from "./HoldingsPieChart.vue?vue&type=script&lang=js&"
export * from "./HoldingsPieChart.vue?vue&type=script&lang=js&"
import style0 from "./HoldingsPieChart.vue?vue&type=style&index=0&id=7e949bd7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e949bd7",
  null
  
)

export default component.exports